import { useCallback, useEffect, useRef, useState } from 'react';
export const useHorizontalScroll = (containerRef, threshold = 8) => {
    const [isAtLeft, setIsAtLeft] = useState(true);
    const [isAtRight, setIsAtRight] = useState(false);
    const [showScrollHint, setShowScrollHint] = useState(false);
    const hideHintTimeoutRef = useRef(null);
    const onMouseEnter = useCallback(() => {
        setShowScrollHint(true);
        if (hideHintTimeoutRef.current) {
            window.clearTimeout(hideHintTimeoutRef.current);
        }
        hideHintTimeoutRef.current = window.setTimeout(() => {
            setShowScrollHint(false);
        }, 1000);
    }, []);
    const onScroll = useCallback(() => {
        if (!containerRef.current)
            return;
        const container = containerRef.current;
        const left = container.scrollLeft <= threshold;
        const right = Math.abs(container.scrollWidth - container.clientWidth - container.scrollLeft) <= threshold;
        if (left !== isAtLeft)
            setIsAtLeft(left);
        if (right !== isAtRight)
            setIsAtRight(right);
        setShowScrollHint(true);
        if (hideHintTimeoutRef.current) {
            window.clearTimeout(hideHintTimeoutRef.current);
        }
        hideHintTimeoutRef.current = window.setTimeout(() => {
            setShowScrollHint(false);
        }, 1000);
    }, [containerRef, threshold, isAtLeft, isAtRight]);
    useEffect(() => {
        onScroll();
    }, []);
    useEffect(() => {
        return () => {
            if (hideHintTimeoutRef.current) {
                window.clearTimeout(hideHintTimeoutRef.current);
            }
        };
    }, []);
    useEffect(() => {
        const containerElement = containerRef.current;
        if (!containerElement || typeof window === 'undefined') {
            return undefined;
        }
        let resizeObserver;
        if ('ResizeObserver' in window) {
            resizeObserver = new ResizeObserver(() => {
                onScroll();
            });
            resizeObserver.observe(containerElement);
        }
        return () => {
            resizeObserver?.disconnect();
        };
    }, [containerRef, onScroll]);
    return {
        isAtLeft,
        isAtRight,
        showScrollHint,
        onMouseEnter,
        onScroll,
    };
};
//# sourceMappingURL=useHorizontalScroll.js.map